globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
export * from './lib/icon-button';
export * from './lib/button';
export * from './lib/icon-button';
export * from './lib/link';
export * from './lib/select';
export * from './lib/skeleton-loading';
export * from './lib/spinner';
export * from './lib/toast';
export * from './lib/text-input';
export * from './lib/countries-menu';
export * from './lib/phone-input';
export * from './lib/radio-group';
export * from './lib/checkbox';